/*
module.exports = file => () => r => require.ensure([], () => r(require('@/views/' + file)))
*/
module.exports = file => () => import('@/views/' + file)



// WEBPACK FOOTER //
// ./src/router/import-production.js